import InputBox from "../../Input/Input";
import Modal from "../../Modal/Modal";
import Button from "../../Button/Button";
import Label from "../../Label/Label";

export const EmailModal: React.FC<{
  onClose?: () => void;
  data: any;
  handleEmailInput: (email: string) => void;
  handleSubmit: () => void;
  isVisible?: boolean;
}> = ({
  onClose,
  data,
  handleEmailInput,
  handleSubmit,
  isVisible,
}) => {

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      id="EmailModal"
      isVisible={isVisible}
      modalBackground={`modal-bg modal-auction`}
      onClose={handleClose}
      title={"Enter Email"}
      body={
        <div className="modal-body bg-modalbody m-3 pt-0 mt-0">
          <div className="mb-3">
            <Label
              className="col-form-label font-inter-400-14"
              text="Email"
              required={false}
            />
            <div className="w-100 position-relative">
              <InputBox
                onChange={(e) => handleEmailInput(e.target.value)}
                className={`form-control application-form-control font-inter-400-14 mb-3`}
                name="email"
                value={data.email}
              />
            </div>
            {data.error && <p className="error-msg mt-2 mb-2">{data.error}</p>}
            <Button
              label={"Submit"}
              onClick={() => handleSubmit()}
              className={`submit-btn mt-0`}
            />
          </div>
        </div>
      }
    />
  );
};
